var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("tag"),
      _vm._v(" "),
      _c("annotation-bookmark"),
      _vm._v(" "),
      _c("share-annotation-bookmark", { key: _vm.shareModalKey }),
      _vm._v(" "),
      _c("remove-annotation-bookmark"),
      _vm._v(" "),
      _c("access-restricted"),
      _vm._v(" "),
      _c("premium-content-category"),
      _vm._v(" "),
      _c("cdp"),
      _vm._v(" "),
      _c("es-errata-srcc"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }